export default __webpack_public_path__ + "static/media/acid-base.f38d6c7d.jpg";